import { lz } from "../../../i18n/localized";
import { METHODS, SELF_HOSTED_LABEL, type MethodId } from "../../methods";

export function MethodChip({ method, full }: { method: MethodId | "self"; full?: boolean }) {
  if (method === "self") {
    return <span className="method self">{lz("domain.selfHosted", SELF_HOSTED_LABEL)}</span>;
  }
  const info = METHODS[method];
  const cls = method === 1 ? "method" : `method m${method}`;
  return <span className={cls}>{full ? info.full : info.short}</span>;
}
